//
import PaymentConditionModel from '@/models/Purchase/PchPaymentCondition'
import ProviderModel from '@/models/Purchase/PchProvider'

//
export default [
    {
        name: 'document_type_number',
        props: {
            chips: true,
            clearable: true,
            items: [
                {
                    text: 'Factura',
                    value: '33',
                },
                {
                    text: 'Nota de Crédito',
                    value: '61',
                },
                {
                    text: 'Nota de Débito',
                    value: '56',
                },
            ],
            label: 'Tipo',
            multiple: true,
        },
        type: 'select',
    },
    {
        name: 'pch_provider_id',
        props: {
            itemText: 'alias_name',
            itemValue: 'id',
            label: 'Proveedor',
            model: ProviderModel,
            noObject: true,
            paramSearch: 'search',
        },
        type: 'autocomplete-model',
        value: [],
    },
    {
        name: 'pch_payment_condition_id',
        props: {
            itemText: 'type',
            itemValue: 'id',
            label: 'Condición de pago',
            model: PaymentConditionModel,
            noObject: true,
            paramSearch: 'type',
        },
        type: 'autocomplete-model',
        value: [],
    },
    {
        name: 'is_exent',
        props: {
            chips: true,
            clearable: true,
            items: [
                {
                    text: 'Si',
                    value: '1',
                },
                {
                    text: 'No',
                    value: '0',
                },
            ],
            label: 'Exenta',
        },
        type: 'select',
        value: [],
    },
    {
        name: 'accounting_date_min',
        type: 'date-field',
        props: {
            clearable: true,
            label: 'Desde',
        },
    },
    {
        name: 'accounting_date_max',
        type: 'date-field',
        props: {
            clearable: true,
            label: 'Hasta',
        },
    },
    {
        name: 'payment_date',
        type: 'date-field',
        props: {
            label: 'Vencimientos',
        },        
    },
    {
        name: 'pending_debts_to_pay',
        type: 'switch',
        props: {
            class: 'pt-3',
            label: 'Pendiente',
        },
    },
]
